<template>
    <div class="flex flex-col min-h-[calc(100vh-32px)] bg-white" data-cy="container_financial_health_quiz_howto">
        <!-- Progress Bar -->
        <QuizProgressBar :currentCategory="currentCategory" :isHowToPage="true" />
        
        <!-- Content -->
        <div class="flex-1 px-4 pb-4 overflow-y-auto">
            <!-- Card -->
            <div class="bg-white rounded-2xl shadow-custom overflow-hidden mt-10 p-4 pb-8">
                <!-- Image -->
                <div class="w-full aspect-[4/3] overflow-hidden">
                    <img 
                        :src="image" 
                        :alt="title"
                        class="w-full h-full object-cover"
                    />
                </div>
                
                <!-- Text Content -->
                <div class="pt-4">
                    <!-- Title -->
                    <h2 class="text-24 font-bold text-a-black mb-3">
                        {{ title }}
                    </h2>
                    
                    <!-- Description -->
                    <p class="text-16 text-a-gray-666666 leading-relaxed">
                        {{ description }}
                    </p>
                </div>
            </div>
        </div>
        
        <!-- Bottom Buttons -->
        <div class="sticky bottom-0 bg-white px-4 py-4">
            <div class="flex gap-3">
                <SecondaryButton 
                    data-cy="btn_financial_health_howto_back"
                    text="ย้อนกลับ"
                    class="flex-1"
                    @click="$emit('back')"
                />
                <PrimaryButton 
                    data-cy="btn_financial_health_howto_next"
                    text="ต่อไป"
                    class="flex-1"
                    @click="$emit('next')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import QuizProgressBar from './QuizProgressBar.vue';
import PrimaryButton from '@/components/Button/PrimaryButton.vue';
import SecondaryButton from '@/components/Button/SecondaryButton.vue';

export default {
    name: "QuizHowTo",
    emits: ['next', 'back'],
    components: {
        QuizProgressBar,
        PrimaryButton,
        SecondaryButton
    },
    props: {
        // Current category index (0-3)
        currentCategory: {
            type: Number,
            required: true
        },
        // Image URL
        image: {
            type: String,
            required: true
        },
        // Title
        title: {
            type: String,
            required: true
        },
        // Description
        description: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped lang="scss"> 
.shadow-custom { 
    box-shadow: 0 9px 20px 0 rgba(0, 0, 0, 0.10); 
    border:1px solid #C8C8CC;
}
</style>